import React, { useContext } from 'react';
import { ModalContext } from '../context/ModalContext';
import '../styles/AlertDialog.scss';

export default function AlertDialog() {
    const modalContext = useContext(ModalContext);

    if (!modalContext.isAlertOpen) return null;

    const handleClose = () => {
        modalContext.setIsAlertOpen(false);
        modalContext.setAlertMessage('');
    };

    return (
        <div className="modal-overlay alert-overlay" onClick={handleClose}>
            <div className="modal-content alert-modal" onClick={(e) => e.stopPropagation()}>
                <div className="modal-body">
                    <div className="alert-message">
                        {modalContext.alertMessage}
                    </div>
                </div>

                <div className="modal-footer">
                    <button className="ok-btn" onClick={handleClose} autoFocus>
                        OK
                    </button>
                </div>
            </div>
        </div>
    );
}
